'use client'

export interface IResearchAdTextItem {
    type: string
    content: string
}

/**
 * The ad's copy block: the title on top (one line), and — when the ad has body copy — a two-line
 * preview of its first copy field. The clamp keeps card heights predictable in the masonry; the
 * full copy lives in the ad's preview modal, so the card carries no disclosure affordance. The
 * copy sits in plain `<p>` elements (drag-selectable — competitor copy is worth copying).
 */
export function ResearchAdCardTextContent({ textContent }: { textContent: IResearchAdTextItem[] }) {
    const [title, preview] = textContent

    if (!title) return null

    return (
        <div className="px-3">
            {/* One line, always — a wrapping title makes card heights unpredictable. `!` sizes
                beat any element typography from an ambient design-system scope (e.g. the public
                board's `.ds2`, whose `h4`/`p` rules would otherwise inflate the card). */}
            <h4 className="min-w-0 truncate font-medium text-sm! leading-snug!">{title.content}</h4>

            {preview && (
                <p className="mt-1 line-clamp-2 text-xs! text-muted-foreground leading-snug!">{preview.content}</p>
            )}
        </div>
    )
}
